/**
 * Service for cropping images.
 */
export const CropImageService = Symbol('CropImageService');
